<template>
  <div
    style="position: absolute; top: 20px; z-index: 1000; right: 10px; width: 75%"
  >
    <div class="map-input-group">
      <input
        type="text"
        class="map-form-control"
        v-model="addressString"
         @click="openSearchTemp"
        @keyup="getSearchLocation"
        placeholder="آدرس تان را وارد نمایید"
        style="text-align: right; direction: rtl"
      />
      <span
        class="map-input-group-text"
        id="getAddressBTN"
        style="border-top-left-radius: 5px; border-bottom-left-radius: 5px"
      >
        <i class="fa fa-search" aria-hidden="true"></i
      ></span>
    </div>
	<div :class="['search-container', { 'show-height': searchTemp }]">
		<ul class="pr-0 bg-light rounded">
			<li class="p-2" v-for="(item, index) in searchResults" :key="index" @click="setStringAddress(item)">
        {{ item.title }}  
        <br />
        <small>{{ item.address }}</small>
      </li>
		</ul>
	</div>
  </div>
  <button
    :disabled="!allow"
    id="confirmAdress"
  >
    تایید آدرس
  </button>
  <div id="map4"></div>
  <div id="marker"></div>
  <div id="centerLocation" class="d-none"></div>
  <button type="button" class="btn btn-light p-0 active" id="myLocationBTN">
    <svg
      v-if="getMyLocationLoading"
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      color="blue"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6C7.3425 6 6 7.3425 6 9C6 10.6575 7.3425 12 9 12C10.6575 12 12 10.6575 12 9C12 7.3425 10.6575 6 9 6ZM15.705 8.25C15.36 5.1225 12.8775 2.64 9.75 2.295V0.75H8.25V2.295C5.1225 2.64 2.64 5.1225 2.295 8.25H0.75V9.75H2.295C2.64 12.8775 5.1225 15.36 8.25 15.705V17.25H9.75V15.705C12.8775 15.36 15.36 12.8775 15.705 9.75H17.25V8.25H15.705ZM9 14.25C6.0975 14.25 3.75 11.9025 3.75 9C3.75 6.0975 6.0975 3.75 9 3.75C11.9025 3.75 14.25 6.0975 14.25 9C14.25 11.9025 11.9025 14.25 9 14.25Z"
        fill="#212121"
      ></path>
    </svg>
    <div
      v-else
      class="spinner-border"
      role="status"
      style="width: 20px; height: 20px; vertical-align: middle"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
  </button>
  <loading-vue v-if="loading" />
</template>
<script setup>
import { ref, reactive, onMounted, defineEmits, defineProps } from "vue";
import * as turf from "@turf/turf";
import LoadingVue from "@/components/section/item/loading.vue";
import { alertBox } from "@/composables/silverBox";

const emit = defineEmits(["location"]);
const props = defineProps(["location"]);

let addressString = ref("");
let loading = ref(false);
let getMyLocationLoading = ref(true);
let finallLocation = reactive({});
let allow = ref(false);
let mainLat = ref(0);
let mainLng = ref(0);
let searchTemp = ref(false);
let debounceTimer;
let searchResults = ref([]);
let myMap;

function inPolygon(lat, lng) {
  let polygon = turf.polygon([
    [
      [35.26152948245568, 60.591402053833015],
      [35.26738119642627, 60.599684715271],
      [35.25424052920554, 60.64221382141114],
      [35.23166865223587, 60.65594673156739],
      [35.21322795517916, 60.63775062561036],
      [35.215191422609855, 60.602130889892585],
      [35.225008047380825, 60.59371948242188],
      [35.26152948245568, 60.591402053833015],
    ],
  ]);
  let point = turf.point([lat, lng]);
  return turf.booleanPointInPolygon(point, polygon);
}
function initMap() {
  const lat = props.location.lat || 35.243154;
  const lng = props.location.lng || 60.624704;
  myMap = new nmp_mapboxgl.Map({
    mapType: "neshanRaster",
    container: "map4",
    zoom: 15,
    pitch: 0,
    center: [lng, lat],
    trackResize: true,
    mapKey: "web.0f8e46e0aba84f5fbdcf09ae6b11532d",
    poi: true,
    traffic: false,
    mapTypeControllerStatus: {
      show: false,
      position: "top-left",
    },
  });
}
function bindEvents() {
  const lat = props.location.lat || 35.243154;
  const lng = props.location.lng || 60.624704;

  const updateCoords = () => {
    mainLat.value = myMap.getCenter().lat;
    mainLng.value = myMap.getCenter().lng;
    allow.value = true;
  };

  const handleOutOfRange = () => {
    alertBox("ما فقط در محدوده تربت جام قادر به سرویس دهی هستیم", "error", 2);
    myMap.flyTo({
      center: [lng, lat],
      essential: true,
      zoom: 16,
    });
    allow.value = true;
  };

  const handleEvent = (e) => {
    const inArea = inPolygon(myMap.getCenter().lat, myMap.getCenter().lng);
    if (inArea) {
      if (e.target.tagName !== "A") updateCoords();
    } else {
      handleOutOfRange();
    }
  };

  document.getElementById("map4").addEventListener("mouseup", handleEvent);
  document.getElementById("map4").addEventListener("touchend", handleEvent);

  window.addEventListener("wheel", () => {
    const inArea = inPolygon(myMap.getCenter().lat, myMap.getCenter().lng);
    if (inArea) {
      updateCoords();
    } else {
      handleOutOfRange();
    }
  });
//   document.getElementById("getAddressBTN").addEventListener("click", getGeoLocation);
  document.getElementById("myLocationBTN").addEventListener("click", getMyLocation);
  document.getElementById("confirmAdress").addEventListener("click", confirmFinallAdress);
}
async function reverse(lat, lng) {
  if (lat > 0 && lng > 0) {
    loading.value = true;
    allow.value = false;
    const url = `https://api.neshan.org/v2/reverse?lat=${lat}&lng=${lng}`;
    const params = {
      headers: {
        "Api-Key": "service.c88b0d1a4ec343338b687e760d7225e6",
      },
    };
    const response = await fetch(url, params);
    const data = await response.json();
    loading.value = false;
    myMap.flyTo({ center: [lng, lat], essential: true, zoom: 16 });
    addressString.value = data.formatted_address.replace("استان خراسان رضوی،", "");
    allow.value = true;
  }
}
function getMyLocation() {
  loading.value = true;
  allow.value = false;
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      if (inPolygon(latitude, longitude)) {
        getMyLocationLoading.value = false;
        setTimeout(() => {
          reverse(latitude, longitude);
          getMyLocationLoading.value = true;
          loading.value = false;
          allow.value = true;
        }, 2000);
      } else {
        loading.value = false;
        allow.value = true;
        alertBox("شما خارج از محدوده تربت جام هستید", "error");
      }
    },
    () => {
      loading.value = false;
      allow.value = true;
      alertBox("مرورگر شما قادر به استفاده از gps نمیباشد، لطفا از کادر جستجو استفاده نمایید");
    }
  );
}
// function getGeoLocation() {
//   if (!addressString.value) return alertBox("لطفا یک آدرس را تایپ کنید");
//   loading.value = true;
//   allow.value = false;
//   const url = `https://api.neshan.org/v4/geocoding?address=${addressString.value}`;
//   const params = {
//     headers: {
//       "Api-Key": "service.c88b0d1a4ec343338b687e760d7225e6",
//     },
//   };
//   fetch(url, params)
//     .then((response) => response.json())
//     .then((data) => {
//       loading.value = false;
//       allow.value = true;
//       const { y: lat, x: lng } = data.location;
//       if (inPolygon(lat, lng)) {
//         myMap.flyTo({ center: [lng, lat], essential: true, zoom: 16 });
//       } else {
//         alertBox("آدرس انتخابی خارج از محدوده تربت جام است", "error");
//       }
//     })
//     .catch((err) => console.log("errors = " + err));
// }
function confirmFinallAdress() {
  reverse(mainLat.value, mainLng.value);
  silverBox({
    html: '<div class="text-center" ><img src="https://radap.ir/imagesUploaded/other/warning.png" width="50" height="50" class="pb-1"/></div><div class="text-start" style="font-weight:700"> الویت ارسال سفارش های شما برحسب نقطه انتخابی شما روی نقشه می باشد</div> <div class="text-start">سفارش شما به آدرسی که لحظاتی پیش انتخاب کردید ارسال میگردد.</div> <div>',
    centerContent: true,
    direction: "rtl",
    closeOnOverlayClick: false,
    cancelButton: {
      borderColor: "green",
      className: "w-50 bg-success mx-auto text-light",
      closeOnClick: true,
      loadingAnimation: true,
      onClick: setAddress,
      showButton: true,
      text: "متوجه شدم",
      textColor: "",
    },
  });
}
function setStringAddress(item){
	addressString.value = item.address
	myMap.flyTo({ center: [item.location.x, item.location.y], essential: true, zoom: 16 });
	searchTemp.value = false
}
async function setAddress() {
  if (!addressString.value) await reverse(mainLat.value, mainLng.value);
  finallLocation.string = addressString.value;
  finallLocation.lat = myMap.getCenter().lat;
  finallLocation.lng = myMap.getCenter().lng;
  emit("location", finallLocation);
}
function getSearchLocation() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(getGeoLocation2, 300);
}
async function getGeoLocation2() {
  searchResults.value = [];
  allow.value = false;
  try {
	if(addressString.value && addressString.value.length){
		const url = `https://api.neshan.org/v1/search?term=${addressString.value}&lat=35.243154&lng=60.624704`;
		const params = {
		headers: {
			"Api-Key": "service.c88b0d1a4ec343338b687e760d7225e6",
		},
		};
		const response = await fetch(url, params);
		const data = await response.json();
		searchTemp.value = true;
		allow.value = true
		let items = data.items.filter((item) =>
			inPolygon(item.location["y"], item.location["x"])
		);
		searchResults.value = items.slice(0, 5);
	}else{
		addressString.value = []
	}

  } catch (error) {
    console.error("Error fetching geolocation:", error);
  }
}
onMounted(() => {
  initMap();
  bindEvents();
});
</script>

<style>
.search-container {
  height: 0;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  margin-top: 0.25em;
}
.show-height {
  height: 50vh;
}
#myLocationBTN {
	width: 32px;
	height: 32px;
	position: absolute;
	z-index: 999;
	top: 80px;
	left: 10px;
}
#myLocationBTN svg {
	vertical-align: middle;
}
#marker {
	background: url("https://safir.radap.ir/static/img/myLocation.png");
	background-size: cover;
	width: 46px;
	height: 60px;
	z-index: 999;
	position: absolute;
	left: calc(50% - 25px);
	top: calc(50% - 60px);
}
#map4 {
	width: 100%;
	height: 560px;
	background: #eee;
	position: absolute;
	z-index: 1;
	top: 0;
	right: 0;
}
#centerLocation {
  background-color: white;
  border: solid 1px #aaaaaa;
  padding: 4px;
  border-radius: 50px;
  width: 320px;
  height: 30px;
  z-index: 998;
  position: absolute;
  left: calc(50% - 160px);
  text-align: center;
  top: 78%;
}
.mapboxgl-ctrl-bottom-right {
  display: none;
}
.control {
  display: none !important;
}
.active {
  color: #f00 !important;
}
#confirmAdress{
	display: block;
	width: 100%;
	height: 40px;
	background-color: #dda7c2;
	position: absolute;
	bottom: 0;
	z-index: 5;
	border: 1px solid #c39393;
	font-weight: 700;
}
</style>
